import { Definition } from "../../../data/Definition";
import { ChartConfigManager } from "../ChartConfigManager";
import { IDimension, IFilter, IItem, IMeasure, IRange } from "../../../data/Query";

const currentVersion = "2";

type ConfigType = {
    version: string,
    dimension: IDimension,
    measure: IMeasure | null,
    spatial: IItem | null,
    filters: IFilter[],
    yRange: IRange | null,
};

export class BarChartConfigManager extends ChartConfigManager {
    private definition: Definition;

    constructor(definition: Definition) {
        super();

        this.definition = definition;
    }

    currentVersion(): string {
        return currentVersion;
    }

    isCurrentVersion(config: any): boolean {
        return config !== null && config.version !== undefined && config.version === currentVersion;
    }

    validate(config: any): boolean {
        return this.isCurrentVersion(config) &&
            config.dimension && config.dimension.source && config.dimension.source.item &&
            config.measure && config.measure.source && config.measure.source.item;
    }

    convert(config: any) {
        return this.isCurrentVersion(config) ? config : this.convertToCurrent(config);
    }

    convertToCurrent(config: any) {
        if (!config) {
            let newConfig = {} as ConfigType;
            newConfig.version = currentVersion;
            return newConfig;
        }

        return this.convertFromV1(config);
    }

    private convertFromV1(config: any): ConfigType {
        let newConfig = {} as ConfigType;
        newConfig.version = currentVersion;

        console.log('convertFromV1 > from', config);

        if (config == null) {
            return newConfig;
        }

        newConfig.dimension = config.dimension;

        // dimension
        if (config.dimension) {
            newConfig.dimension = {
                source: {
                    item: config.dimension.item,
                    sub: null
                },
                bin: config.dimension.bin
            }
        }

        // measure
        if (config.measure) {
            newConfig.measure = {
                source: {
                    item: config.measure.item,
                    sub: null
                },
                aggregation: config.measure.agg
            }
        }

        // spatial
        if (config.spatial && config.spatial.item) {
            newConfig.spatial = {
                item: config.spatial.item,
                sub: null
            }
        }

        // filters
        if (config.filters) {
            newConfig.filters = config.filters.map((filter: any) => {
                return {
                    source: {
                        item: filter.item,
                        sub: null
                    },
                    operation: filter.operation,
                    value: filter.value
                };
            });
        }

        console.log('convertFromV1 > to', newConfig);

        return newConfig;
    }
}
